"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class OverviewModalRow extends React.Component {
    constructor(props) {
        super(props);
        this.getProgress = this.getProgress.bind(this);
    }
    getProgress() {
        const { val, device, name } = this.props;
        const isValNumber = (x) => {
            return x !== undefined;
        };
        let ret;
        if (isValNumber(val)) {
            if (val === -1) {
                ret = null;
            }
            else if (val === 100) {
                ret = (React.createElement("div", { style: { display: 'flex', marginTop: 8 } },
                    React.createElement(src_1.CheckCircleIcon, { fill: src_1.green })));
            }
            else {
                ret = (React.createElement("div", { style: { display: 'flex', marginTop: 8 } },
                    React.createElement(src_1.ProgressBar, { progress: val, style: {
                            progressStyle: {
                                backgroundColor: src_1.turquoise,
                            },
                            barStyle: {
                                width: device === 'Desktop' ? 240 : 176,
                            },
                        } }),
                    React.createElement("div", { style: { marginLeft: 16 } },
                        React.createElement(src_1.Text, { text: `${val}% complete`, size: "small" }))));
            }
        }
        return ret;
    }
    render() {
        let { device, name, text, val, openWizard } = this.props;
        let outerStyle = {
            padding: '24px 32px 0 32px',
            display: 'flex',
            flexDirection: 'column',
        };
        let button = (React.createElement(src_1.Button, { text: "Edit", size: "small", type: "primary", onClick: () => openWizard(name.toLowerCase().split(' ').join('')), style: { outerStyle: { marginLeft: 32 } } }));
        const experienceOff = name === 'Experience' && val === false;
        let textStyle = experienceOff ? { color: src_1.silver } : { color: src_1.charcoal };
        if (device === 'Mobile') {
            outerStyle = Object.assign(Object.assign({}, outerStyle), { padding: '24px 24px 0 24px' });
        }
        if (device !== 'Desktop') {
            button = (React.createElement("div", { style: { marginLeft: 16 } },
                React.createElement(src_1.ChevronRightIcon, { fill: src_1.silver })));
        }
        if (experienceOff) {
            button = (React.createElement("div", { style: {
                    width: 100,
                    height: 28,
                    marginLeft: 16,
                } }));
        }
        return (React.createElement("div", { style: { background: src_1.white, width: '100%' }, onClick: !experienceOff && openWizard !== undefined
                ? () => openWizard(name.toLowerCase().split(' ').join(''))
                : () => null },
            React.createElement("div", { style: outerStyle },
                React.createElement(src_1.Text, { text: name === 'Scheduled Delivery' || name === 'Automated Delivery' ? 'Delivery' : name, size: "h2", textStyle: textStyle }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement(src_1.Text, { text: text, size: "medium", textStyle: textStyle }),
                    openWizard !== undefined && button),
                name !== 'Experience' && this.getProgress(),
                experienceOff && (React.createElement("div", { style: {
                        display: 'flex',
                        marginTop: 16,
                    } },
                    React.createElement(src_1.Alert, { message: "Tap behavior is set to present website", type: "info" }))),
                this.props.children,
                React.createElement("div", { style: {
                        marginTop: 24,
                        height: 1,
                        width: '100%',
                        background: src_1.titanium,
                    } }))));
    }
}
exports.default = OverviewModalRow;
